<mat-toolbar>
  <!-- Begin Menu Toggle -->
  @if (!hideToggle) {
    <div class="toolbar-item">
      <div class="toggle-container">
        <nts-text-button (onClicked)="onToggleMenu()" [icon]="'menu-align'"></nts-text-button>
      </div>
    </div>
  }
  <!-- End Menu Toggle -->

  <!-- Begin Brand Image -->
  <div class="toolbar-item">
    <a class="header-brand">
      <img src="assets/std/images/logo.png" alt="NTS Cloud" class="header-brand-img" (click)="onClickLogo.emit()">
      <div class="header-brand-name"></div>
    </a>
  </div>
  <!-- End Brand Image -->

  <span class="toolbar-spacer"></span>

  <!-- Begin Offline Icon -->
  @if (!(isOnline$ | async)) {
    <div class="toolbar-item">
      <svg-icon popperApplyClass="alert" popper="Modalità offline" class="connection-issue" key="wifi-off"></svg-icon>
    </div>
  }
  <!-- End Offline Icon -->

  <!-- Begin Tenant Button -->
  <div class="toolbar-item" #tenantMenuToggle #tenantMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="tenantMenu"
    (menuOpened)="tenantMenuOpened()">
    @if (!tenantRefreshing) {
      <div>
        @if (tenant?.businessName) {
          <nts-user-image [email]="$safeNavigationMigration(tenant?.email)"
            [base64]="$safeNavigationMigration(tenant?.base64Image)">
          </nts-user-image>
        } @else {
          <div class="no-tenant-icon">
            <span class="ms-Icon ms-Icon--UserWarning" role="presentation"
            style="display: flex; flex-direction: column; font-size: 16px;"></span>
          </div>
        }
      </div>
    }
    @if (tenantRefreshing) {
      <div>
        <nts-spinner [isVisible]="true"></nts-spinner>
      </div>
    }
  </div>
  <mat-menu #tenantMenu="matMenu" [hasBackdrop]="false" xPosition="after">
    <ng-template matMenuContent>
      <div class="detail-container">

        <div class="content-container" (click)="$event.stopPropagation()">
          <div class="image-contaier">
            @if (tenant?.businessName) {
              <nts-user-image
                [email]="$safeNavigationMigration(tenant?.email)"
                [base64]="$safeNavigationMigration(tenant?.base64Image)"
                [size]="60">
              </nts-user-image>
            } @else {
              <div class="no-tenant-profile">
                <span class="ms-Icon ms-Icon--UserWarning" role="presentation"
                style="display: flex; flex-direction: column; font-size: 16px;"></span>
              </div>
            }
          </div>
          <div class="info-contaier">
            <div class="info-line business-name">
              {{ tenantRefreshing ? ('ChangeTenant_TenantCheckingMessage' | NTSTranslate) : ( tenant ?
              tenant?.businessName : ('ChangeTenant_NotSetMessage'| NTSTranslate)) }}
            </div>
            <div class="info-line additional-info">
              {{ tenant ? (tenant?.vatNumber + '-' + getTenantTypeDescription($safeNavigationMigration(tenant?.tenantType)))
              : '' }}
            </div>
          </div>
        </div>
        <div class="actions-container">
          <nts-ribbon-button (onClicked)="changeTenant()"
          [label]="(tenantRefreshing || tenant?.businessName) ? ('ChangeTenant_ChangeTenant_DisplayName' | NTSTranslate) : ('ChangeTenant_SetTenant_DisplayName' | NTSTranslate)"></nts-ribbon-button>
          <nts-ribbon-button (onClicked)="logOut()" icon="log-out"></nts-ribbon-button>
        </div>
      </div>
    </ng-template>
  </mat-menu>
  <!-- End Tenant Button -->

  <!-- Begin User Button -->
  <div class="toolbar-item" #userMenuToggle #userMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="userMenu"
    (menuOpened)="userMenuOpened()">
    <nts-user-image [email]="$safeNavigationMigration(user?.loginInformation?.email)" [base64]="$safeNavigationMigration(user?.base64Image)">
    </nts-user-image>
  </div>
  <mat-menu #userMenu="matMenu" [hasBackdrop]="false" xPosition="after">
    <ng-template matMenuContent>
      <div class="detail-container">

        <div class="content-container" (click)="$event.stopPropagation()">
          <div class="image-contaier">
            <nts-user-image
              [email]="$safeNavigationMigration(user?.loginInformation?.email)"
              [size]="60"
              [base64]="$safeNavigationMigration(user?.base64Image)">
            </nts-user-image>
          </div>
          <div class="info-contaier">
            <div class="info-line business-name">
              {{ user?.name }} {{ user?.lastName }}
            </div>
            <div class="info-line additional-info">
              {{ user?.loginInformation?.email }}
            </div>
          </div>
        </div>
        <div class="actions-container">
          @if (isOnline$ | async) {
            <nts-ribbon-button (onClicked)="openProfile()"
            [label]="'UserProfile_ViewProfile_DisplayName'|NTSTranslate"></nts-ribbon-button>
          }
          <nts-ribbon-button (onClicked)="logOut()" icon="log-out"></nts-ribbon-button>
        </div>
      </div>
    </ng-template>
  </mat-menu>
  <!-- End User Button -->

  <!-- Begin Enterprise Section -->
  @if (enterpriseList?.enterprises?.length > 0) {
    <div class="toolbar-item enterprise-item" #enterpriseMenuToggle #enterpriseMenuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="enterpriseMenu"
      (menuOpened)="enterpriseMenuOpened()">
      <div class="enterprise-icon" [style.backgroundColor]="currentCompanyColor">
        <svg-icon key="home" fontSize="29px"></svg-icon>
      </div>
      <div class="enterprise-container">
        <div class="enterprise-description">{{currentEnterprise?.description ? currentEnterprise?.description: ''}}
        </div>
        <div class="company-description">{{currentCompany?.description ? currentCompany?.description: ''}}</div>
      </div>
    </div>
  }
  @if (isEnterpriseBarrierRequired) {
    <mat-menu #enterpriseMenu="matMenu" [hasBackdrop]="false" xPosition="after">
      <ng-template matMenuContent>
        <div class="enterprise-detail-container">
          <div class="enterprise-content-container" (click)="$event.stopPropagation()">
            <div class="enterprise-content-item">
              {{'ChangeEnterprise_SelectEnterprise_DisplayName'|NTSTranslate}}
              <nts-base-enum-text-box
                [options$]="enterpriseSelectorViewModel.enterpriseList$"
                [(value)]="enterpriseSelectorViewModel.selectedEnterprise"
              (valueChange)="enterpriseSelectorViewModel.onEnterpriseChange($event)"></nts-base-enum-text-box>
            </div>
            <div class="enterprise-content-item">
              {{'ChangeEnterprise_SelectCompany_DisplayName'|NTSTranslate}}
              <nts-base-enum-text-box
                [isDisabled]="(enterpriseSelectorViewModel.filteredCompanyList$ | async)?.length === 0"
                [options$]="enterpriseSelectorViewModel.filteredCompanyList$"
                [(value)]="enterpriseSelectorViewModel.selectedCompany"
              (valueChange)="enterpriseSelectorViewModel.onCompanyChange($event)"></nts-base-enum-text-box>
            </div>
          </div>
          <div class="actions-container">
            <nts-ribbon-button [label]="'ChangeEnterprise_Cancel_DisplayName'|NTSTranslate"
            (onClicked)="closeAll()"></nts-ribbon-button>
            <!-- <nts-ribbon-button (onClicked)="logOut()" icon="log-out"></nts-ribbon-button> -->
            <nts-filled-button icon="check" [label]="'ChangeEnterprise_Confirm_DisplayName'|NTSTranslate"
            [type]="filledButtonType.Info" (onClicked)="changeEnterpriseAndCompany()"></nts-filled-button>
          </div>
        </div>
      </ng-template>
    </mat-menu>
  }
  <!-- End Enterprise Section -->
</mat-toolbar>